module.exports = __webpack_public_path__ + "img/4.ed095862.jpeg";